/**
 * @description Hook utilizado para manipular os cargos de usuários
 * @author Diego Sabino Amorim de Araújo
 * @file useCargoService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import actionTypes from 'utils/actionTypes'
import { useDispatch } from 'react-redux'
import { useFetch } from './useFetch'

export const useCargoService = () => {
  const fetch = useFetch()
  const dispatch = useDispatch()

  const listarCargosAsync = async (externos=false, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`cargos${externos ? '/externos' : ''}`)
      return response.data.cargos
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarCargosGlobal = async (setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`cargos`)
      dispatch({
        type: actionTypes.FETCH_CARGOS,
        cargos: response.data.cargos,
      })
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarCargoAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`cargos/${id}`)
      return response.data.cargo
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const cadastrarCargo = async (dados, setProcessando) => {
    if (setProcessando) setProcessando(true)
    const novoCargo = {
      nome: dados.nome,
      sigla: dados.sigla,
      descricao: dados.descricao,
      permissoes: dados.permissoes,
    }
    await fetch.postOpen('/cargos/', novoCargo)
    if (setProcessando) setProcessando(false)
  }

  const editarCargo = async (id, dados, setProcessando) => {
    if (setProcessando) setProcessando(true)
    const cargo = {
      id: dados.id,
      nome: dados.nome,
      sigla: dados.sigla,
      descricao: dados.descricao,
      permissoes: dados.permissoes,
    }
    await fetch.putOpen(`/cargos/${id}`, cargo)
    if (setProcessando) setProcessando(false)
  }

  const deletarCargo = async (id, setProcessando) => {
    if (setProcessando) setProcessando(true)
    await fetch.del(`cargos/${id}`)
    if (setProcessando) setProcessando(false)
  }

  return {
    listarCargosAsync,
    listarCargosGlobal,
    listarCargoAsync,
    deletarCargo,
    cadastrarCargo,
    editarCargo,
  }
}
